import { Box, Grid } from '@material-ui/core';
import { TravelCategory } from '@nemuru-eng/js-api-client';
import { useFormContext } from 'react-hook-form';

import { getMaxDate } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/utils/getMaxDate';
import { getMinDate } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/utils/getMinDate';
import { Font } from '@/components/shared/components/Font';
import { DateFormField } from '@/components/shared/components/NewContextForms/DateFormField';
import { SelectFormField } from '@/components/shared/components/NewContextForms/SelectFormField';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';
import { Text } from '@/components/shared/components/Text';
import { useTranslation } from '@/components/shared/hooks/useTranslation';

export const TravelForm = () => {
  const { getTextIdTranslation } = useTranslation();
  const { watch } = useFormContext();

  return (
    <Box width={'100%'}>
      <Font variant="h4" color="textPrimary">
        <Text strong tId={'TRAVEL_DETAILS'} />
      </Font>
      <Box mt={2} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextFormField
            name={'item.destination'}
            label={'TRAVEL_DESTINATION'}
            placeholder={getTextIdTranslation('TRAVEL_DESTINATION_PLACEHOLDER')}
            fieldVariant={FieldVariant.form}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <SelectFormField
            name={'item.travelCategory'}
            label={'TRAVEL_CATEGORY'}
            selectOptions={Object.values(TravelCategory).map((category) => ({
              value: category,
              display: <Text tId={`TRAVEL_CATEGORY_${category}`} />,
            }))}
            fieldVariant={FieldVariant.form}
          />
        </Grid>
        <Grid item xs={12}>
          <TextFormField
            name={'item.optionalDescription'}
            label={'TRAVEL_DESCRIPTION'}
            placeholder={getTextIdTranslation('TRAVEL_DESCRIPTION_PLACEHOLDER')}
            fieldVariant={FieldVariant.form}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <DateFormField
            name={'item.startDate'}
            label={'START_DATE'}
            fieldVariant={FieldVariant.form}
            maxDate={getMaxDate(watch('item.endDate'))}
            disablePast
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <DateFormField
            name={'item.endDate'}
            label={'END_DATE'}
            fieldVariant={FieldVariant.form}
            minDate={getMinDate(watch('item.startDate'))}
            disablePast
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextFormField
            name={'item.travellers'}
            type={'number'}
            InputProps={{ inputProps: { min: 1 } }}
            label={'TRAVEL_TRAVELLERS'}
            fieldVariant={FieldVariant.form}
          />
        </Grid>
      </Grid>
    </Box>
  );
};
